import { useState } from "react";
import { Modal } from "react-bootstrap";

// Componente ImageModal
const ImageModal = ({ show, onHide, imageSrc, imageAlt = "preview", camera = "NN" }) => {
    return (
        <Modal show={show} onHide={onHide} size="xl" centered scrollable={true}>
            <Modal.Header closeButton style={{ backgroundColor: "rgb(137 137 137 / 56%)", border: "none" }}>
                <Modal.Title className="ms-auto">{imageAlt + " - " + camera}</Modal.Title>
            </Modal.Header>
            <Modal.Body
                className="d-flex align-items-center justify-content-center p-0"
                style={{ backgroundColor: "rgb(137 137 137 / 56%)" }}>
                <img src={imageSrc} alt={imageAlt + " - " + camera} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} />
            </Modal.Body>
        </Modal>
    );
};
export default ImageModal;
